<template>
	<q-card
		v-if="$q.platform.is.desktop"
		class="q-py-sm cursor-pointer shadow-transition card-material"
	>
		<q-tooltip>
			{{ $t('loading') }}
		</q-tooltip>
		<q-card-section>
			<div class="row q-col-gutter-md">
				<div class="col-12">
					<q-skeleton type="QToggle" />
				</div>

				<div class="col-12">
					<span class="text-h5 title">
						<q-skeleton type="text" />
					</span>
					<span class="text-grey-6">
						<q-skeleton type="text" />
					</span>
				</div>
			</div>
		</q-card-section>
	</q-card>

	<q-card v-else class="bg-grey-10 q-mb-md">
		<q-card-section>
			<div class="row flex items-center">
				<div class="col-2">
					<q-skeleton type="QToggle" />
				</div>
				<div class="offset-1 col-8 q-pl-sm text-white">
					<q-skeleton type="text" />
					<div class="col-4">
						<q-skeleton type="text" />
					</div>
				</div>
			</div>
		</q-card-section>
	</q-card>
</template>

<script setup></script>

<style lang="scss" scoped>
.card-material {
	min-height: 160px;
	cursor: wait;
}
</style>
